import { Suspense, type FC } from 'react';
import { Titled } from 'react-titled';
import ProgressSkeleton from 'components/layout/ProgressSkeleton';
import { RuleEdit } from 'features/rules';
import { Box } from '@mui/material';

const RuleEditPage: FC = () => {
  return (
    <Box sx={{ display: 'flex', flexGrow: 1, position: 'relative' }}>
      <Titled title={(title) => `AutoRules | ${title}`} />
      <Suspense fallback={<ProgressSkeleton />}>
        <RuleEdit mode="edit" />
      </Suspense>
    </Box>
  );
};

export default RuleEditPage;
